/*!

=========================================================
* Argon Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
// react library for routing
// reactstrap components
import {
    Button,
    Card,
    CardImg,
    CardSubtitle,
    CardTitle,
    Col,
    Collapse,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    Nav,
    NavItem,
    NavLink,
    Row,
    UncontrolledTooltip
} from 'reactstrap';
// core components
import ContentService from "../services/xgContentService";
import _ from "lodash";
import UtilService from "../services/utilService";
import Login from "./pages/auth/Login";
import Paginations from "./Paginations";
import FormReactSelect from "../components/common/form/FormReactSelect";
import {contentType} from "../util/contentType";
import {contentCategory} from "../util/contentCategory";
import {isMobile} from "react-device-detect";
import AppNavBar from "./AppNavBar";
import NotificationAlert from "react-notification-alert";
import SecurityService from "../services/securityService";
import isTrainingSession from "./pages/util/isTrainingSession";
import {subscriptionType} from "../util/subscriptionType";
import {contentArticleType} from "../util/contentArticleType";
import ReviewService from "../services/reviewService";
import DownloadUtil from "../util/downloadUtil";
import ReviewCompaniesCarousel from "./ReviewCompaniesCarousel";
import Rating from "react-rating";

class XareView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            term: "",
            collapseSearchServices: false,
            collapseSearchArticles: false,
            collapseSearchReviews: false,
            completeContentList: [],
            searchList: [],
            loginModal: false,
            currentPage: 1,
            pageSize: 9, // 8 items to display 4 per row (2 rows per page)
        };
        this.onPageChange = this.onPageChange.bind(this);
    }

    onPageChange(pageNumber) {
        this.setState({currentPage: pageNumber});
    }

    trimmedTitle = (title) => {
        if (!title) return '';

        if (title.length > 60) {
            return title.substring(0, 60) + '...';
        }

        // Add non-breaking spaces (&nbsp;) to make it exactly 60 characters
        return title + '\u00A0'.repeat(60 - title.length);
    };


    icon = (item) => {
        let icon;
        switch (item.contentType) {
            case 'TEXT':
                icon = "fa fa-file-alt";
                break;
            case 'VIDEO':
                icon = "fa fa-video";
                break;
            case 'AUDIO':
                icon = "fa fa-headphones";
                break;
            default:
                icon = "fa fa-file-alt"; // Default icon if type is unknown
        }
        return icon;
    }

    componentDidMount() {
        ReviewService.xareviewData().then((response) => {
            console.log(response);
            this.setState({completeContentList: response});
            this.setState({searchList: response});
            this.toggleSearchReviews();
        });
    }

    onPageChange(pageNumber) {
        this.setState({currentPage: pageNumber});
    }

    renderCards(items) {
        return (
            <Container>
                {items.map((item) => (
                    <Row key={UtilService.uuidv4()} className="align-items-lg-start mb-4 p-3 border rounded" style={{ backgroundColor: "#f8f9fe" }}>
                        {/* Column 1: Logo */}
                        <Col xs="12" md="2" className="text-center mb-3 mb-md-0">
                            <img
                                src={item.brandLogoUID === null ? require("assets/img/brand/companies.jpeg") : DownloadUtil.generateUrl(item.brandLogoUID)}
                                alt="Company Logo"
                                style={{ width: "156px", height: "156px", objectFit: "contain" }}
                            />
                        </Col>

                        {/* Column 2: Company Name and Score */}
                        <Col xs="12" md="4" className="mb-3 mb-md-0">
                            <h4 className="font-weight-bold"><b>{item.companyName}</b></h4>
                            <p>Average Score: {item.score?.toFixed(1) ?? "0.0"}/5</p>
                            <Rating
                                readonly
                                initialRating={item.score}
                                emptySymbol={<i className="fa fa-star text-muted" />}
                                fullSymbol={<i className="fa fa-star text-warning" />}
                                fractions={2}
                                title={item.score?.toFixed(1)}
                            />
                            <p>Total Reviews - ({item?.scoreBreakdown?.totalReviews || 0})</p>
                        </Col>

                        {/* Column 3: Review Count and Breakdown */}
                        <Col xs="12" md="6">
                            {/*<p><b><strong>Breakdown:</strong></b> {item.scoreBreakdown?.breakdown?.length ?? 0}</p>*/}

                            {item.scoreBreakdown?.breakdown?.length > 0 ? (
                                <Row>
                                    {item.scoreBreakdown.breakdown.map((entry, index) => (
                                        <Col key={index} xs="12" sm="12" className="mb-2">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span style={{ fontSize: "0.9rem" }}>{entry.question}:</span>
                                                <span style={{ whiteSpace: "nowrap", marginLeft: "0.5rem" }}>
                                                <Rating
                                                    readonly
                                                    initialRating={entry.breakdownScore}
                                                    emptySymbol={<i className="fa fa-star text-muted" />}
                                                    fullSymbol={<i className="fa fa-star text-warning" />}
                                                    fractions={2}
                                                    title={entry.breakdownScore.toFixed(1)}
                                                />
                                                <span className="ml-2">{entry.breakdownScore.toFixed(1)}/5</span>
                                            </span>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            ) : (
                                <p className="text-muted mt-2">No breakdown available</p>
                            )}
                        </Col>
                    </Row>
                ))}
            </Container>
        );
    }

    toggleModal = state => {
        this.setState({
            [state]: !this.state[state]
        });
    };

    toggleSearchServices = (event) => {
        event.preventDefault();
        this.props.history.push("/");
    }

    toggleSearchArticles = () => {
        event.preventDefault();
        this.props.history.push("/knowledgeCentre");
    }

    toggleSearchReviews = () => {
        this.setState({
            collapseSearchReviews: !this.state.collapseSearchReviews,
            collapseSearchArticles: false,
            collapseSearchServices: false // Close the services section when articles is toggled
        });
    }

    onSearchInputChange = (event) => {
        let term = event.target.value;
        this.setState({term: event.target.value})
        console.log(this.state.term)
    }

    onSearch = event => {
        const filteredItems = _.filter(this.state.completeContentList, (item) => {
            return _.includes(item.companyName.toLowerCase(), this.state.term.toLowerCase())
        });
        console.log(filteredItems)
        this.setState({searchList: filteredItems});
    }

    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };

    showData = (paginatedItems, completeContentList, paz) =>{
        if(paginatedItems.length > 0){
           return ( <>

           </>)
        } else{
            return <h1>No Data available to show!</h1>
        }
    }



    render() {
        const {completeContentList, currentPage, pageSize, searchList} = this.state;
        const startIndex = (currentPage - 1) * pageSize;
        const paginatedItems = searchList.slice(startIndex, startIndex + pageSize);

        return (
            <div>
                {/*Nav Bar*/}
                <AppNavBar loginModalToggle={this.toggleModal}/>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                {/* Hero Banner */}
                <div className="hero-banner">
                    <Container fluid>
                        <Row>
                            <Col>
                                <div className="hero-banner-content">
                                    <p style={{textAlign: "start"}}>Company Reviews </p>
                                    <h1 style={{textAlign: "start"}}>Brands you can trust.</h1>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <br/>
                <br/>
                <br/>
                {/* Collapsible Sections */}
                <Container className={"mt-10"}
                           style={{
                               border: "2px solid #4E5F7A",
                               padding: "1.5rem",
                               borderRadius: "2px",
                               marginTop: "2.5rem", // Adjust to divide the buttons in half
                               position: "relative",
                               zIndex: "1"
                           }}>
                    {/* Search Services */}
                    <div className="text-center" style={{marginTop: "-4rem"}}>
                        <Button color="white" onClick={this.toggleSearchServices} className="mb-3"
                                style={{
                                    width: "30%",
                                    fontSize: "1.5rem",
                                    padding: "1.5%"
                                }}>
                            {isMobile ? "Services" : "Services"}
                        </Button>
                        {/* Search Articles */}
                        <Button color="white" onClick={this.toggleSearchArticles} className="mb-3"
                                style={{
                                    width: "30%",
                                    fontSize: "1.5rem",
                                    padding: "1.5%",
                                    marginLeft: "-0.5rem"
                                }}>
                            {isMobile ? "Knowledge" : "Knowledge"}
                        </Button>
                        {/*Xare View*/}
                        <Button color="default" className="mb-3"
                                style={{
                                    width: "30%",
                                    fontSize: "1.5rem",
                                    padding: "1.5%",
                                    marginLeft: "-0.4rem"
                                }}>
                            {isMobile ? "Reviews" : "Reviews"}
                        </Button>
                    </div>
                    <Collapse isOpen={this.state.collapseSearchServices}>
                    </Collapse>


                    <Collapse isOpen={this.state.collapseSearchArticles}>
                    </Collapse>
                    <Collapse isOpen={this.state.collapseSearchReviews}>
                        <Form onSubmit={(e) => {
                            e.preventDefault()
                            this.onSearch();
                        }}>
                            <FormGroup>
                                <Label for="searchText">Search Companies</Label>
                                <Input onChange={this.onSearchInputChange} type="text" name="searchText"
                                       id="searchText"/>
                            </FormGroup>
                            <div className="text-center">
                                <Button color="default" outline onClick={this.onSearch}
                                        type="button">{"Search"}</Button>
                            </div>
                        </Form>
                    </Collapse>
                </Container>
                <br/>
                <br/>
                <br/>
                <Container>

                    {paginatedItems.length > 0 ?
                        <>
                            {this.renderCards(paginatedItems)}
                        <Paginations
                            totalItems={completeContentList.length}
                            pageSize={pageSize}
                            currentPage={currentPage}
                            onPageChange={this.onPageChange}
                        />
                        {/*<ReviewCompaniesCarousel companies={completeContentList}/>*/}
                    </> : (<h1>No Company Reviews Available!</h1>)}


                </Container>
                <Modal
                    // size={"lg"}
                    className="modal-dialog-centered"
                    isOpen={this.state.loginModal}
                    toggle={() => this.toggleModal("loginModal")}
                >
                    <Login/>
                </Modal>
                <footer className="py-5" id="footer-main">
                    <Container>
                        <Row className="align-items-center justify-content-xl-between">
                            <Col xl="6">
                                <div className="copyright text-center text-xl-left text-muted">
                                    © {new Date().getFullYear()}{" "}
                                    <a
                                        className="font-weight-bold ml-1"
                                        href="https://sekim-international.com/"
                                        target="_blank"
                                    >
                                        Sekim International
                                    </a>
                                </div>
                            </Col>
                            <Col xl="6">
                                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                                    <NavItem>
                                        <NavLink
                                            href="https://xaregrowth.com"
                                            target="_blank"
                                        >
                                            XareGrowth
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            href=""
                                            target="_blank"
                                            onClick={(event) => {
                                                this.props.history.push("/aboutUs")
                                            }}
                                        >
                                            About Us
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </div>
        );
    }
}

export default XareView;
